import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="email-3, envelope"><path d="M21.9844 7.41638C21.8156 5.50159 20.2077 4 18.249 4H5.74903C3.7904 4 2.18248 5.50159 2.01367 7.41637C4.58491 9.94212 8.11004 11.5 11.999 11.5C15.888 11.5 19.4132 9.94212 21.9844 7.41638Z" fill="currentColor"/><path d="M22 9.4187C19.2802 11.6564 15.797 13 12 13C8.20301 13 4.71984 11.6564 2 9.4187V16.25C2 18.3211 3.67893 20 5.75 20H18.25C20.3211 20 22 18.3211 22 16.25V9.4187Z" fill="currentColor"/></CentralIconBase>;
};

export default IconEmail3;
